import { t } from '@lingui/macro';

import TextField from '@decisiv/ui-components/lib/components/TextField';
import { P } from '@decisiv/ui-components/lib/components/Typography';

import { formatYmm } from '../utils/formatYmm';
import { FieldWrapper, Row } from './styles';

interface UnitNumberRowProps {
  vin: string;
  year?: string | null;
  make?: string | null;
  model?: string | null;
  value: string;
  onChange: (vin: string, value: string) => void;
}

export default function UnitNumberRow({
  vin,
  year,
  make,
  model,
  value,
  onChange,
}: UnitNumberRowProps) {
  const ymm = formatYmm(year, make, model);

  return (
    <Row>
      <div>
        <P size="small" color="alaskanHusky">
          VIN {vin}
        </P>
        {ymm && <P>{ymm}</P>}
      </div>
      <FieldWrapper>
        <TextField
          label={t`Unit Number`}
          hideLabel
          name={`unit-number-${vin}`}
          value={value}
          onChange={(e) => onChange(vin, e.target.value)}
        />
      </FieldWrapper>
    </Row>
  );
}
